import React from "react";
import Card from "@/components/Card/Card";
import { COMMUNITY_CONTENT } from "@/config/communityConfig";

interface Props {
  type: "learningCoach" | "student";
  linkUrl?: string;
  orientation?: "vertical" | "horizontal";
  descriptionOverride?: string;
  themeOverride?: 'primary' | 'primary-light' | 'secondary-light' | 'white';
  hideEyebrow?: boolean;
  mediaOverride?: string;
  buttonTextOverride?:string;
  buttonDisabled?: boolean;
}

const CommunityCard: React.FC<Props> = ({
  type,
  linkUrl,
  orientation = "vertical",
  descriptionOverride,
  themeOverride,
  hideEyebrow = false,
  mediaOverride,
  buttonTextOverride,
  buttonDisabled = false,
}) => {
  const content = COMMUNITY_CONTENT[type];
  const buttonLabel = buttonTextOverride || content.buttonText;

  return (
    <Card
      theme={themeOverride || content.theme}
      orientation={orientation}
      eyebrow={hideEyebrow ? "" : content.eyebrow}
      header={content.header}
      description={descriptionOverride || content.description}
      buttonText={buttonDisabled ? undefined : buttonLabel}
      buttonProps={
        buttonDisabled
          ? {
              label: buttonLabel,
              disabled: true,
            }
          : undefined
      }
      media={mediaOverride || content.media}      
      videoUuid={content.videoUuid} 
      linkUrl={buttonDisabled ? undefined : linkUrl}
      linkTarget="_blank"
    />
  );
};

export default CommunityCard;
